import { EMPTY, Observable, of, TimeoutError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable, Injector, NgZone, OnInit } from '@angular/core';
//for catch:
import { catchError } from 'rxjs/operators';

//for throw:
import { throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppInjector } from '../app-injector';
export interface ApiServiceInterface {
	getHttpHeaders(): HttpHeaders;
	setHttpHeaders(httpHeaders: HttpHeaders): HttpHeaders;
	get(url: string, params?: HttpParams, httpHeaders?: HttpHeaders): Observable<any>;
	post(url: string, data: any, httpHeaders?: HttpHeaders): Observable<any>;
	put(url: string, data: any, httpHeaders?: HttpHeaders): Observable<any>;
	delete(url: string, httpHeaders?: HttpHeaders): Observable<any>;
	patch(url: string, data: any, httpHeaders?: HttpHeaders): Observable<any>;
}

@Injectable({
	providedIn: 'root',
})

export class ApiService implements ApiServiceInterface , OnInit {

	private router : any;
	constructor(private httpClient: HttpClient,
		@Inject(Injector) private readonly injector: Injector, private zone: NgZone) {
	}

	ngOnInit(): void {

	}

	private httpHeaders: HttpHeaders = new HttpHeaders(
		{
			'Content-Type': 'application/json',
			//'Access-Control-Allow-Origin' : '*'
			/*'Authorization': 'jwt-token'*/
		});


	public getHttpHeaders(): HttpHeaders {
		return this.httpHeaders;
	}
	public setHttpHeaders(httpHeaders: HttpHeaders): HttpHeaders {
		this.httpHeaders = httpHeaders;
		return this.getHttpHeaders();
	}

	public getAuthHeader() {
		const headers = new HttpHeaders()
		  .set('Authorization', 'Bearer ' + localStorage.getItem("BearerToken"));
		if (headers) {
		  return headers;
		}
	}

	public customGet(url: string, params?: HttpParams): Observable<any> {
		let headers = this.getAuthHeader();
		if (params != null) {
			return this.httpClient.get<any>(url, { headers: headers, params: params });
		} else {
			return this.httpClient.get<any>(url, { headers: headers })
			.pipe(catchError(error => this.handleError(error)));
		}

	}

	public get(url: string, params?: HttpParams, httpHeaders?: HttpHeaders): Observable<any> {
		let headers = httpHeaders != null ? httpHeaders : this.httpHeaders;
		if (params != null) {
			return this.httpClient.get<any>(url, { headers: headers, params: params })
			.pipe(catchError(error => this.handleError(error)));
		} else {
			return this.httpClient.get<any>(url, { headers: headers })
			.pipe(catchError(error => this.handleError(error)));
		}
	}

	private handleError(error: HttpErrorResponse | any) {
		//console.error('ApiService::handleError', error);
		let toaster = AppInjector.get(ToastrService);
			toaster.clear();
			toaster.toastrConfig.maxOpened = 1; // Cleaner code needed here
		if (error.status === 503) {
			toaster.error("Service is temporarily unavailable. Please try again in a moment.", 'Error',{
				timeOut: 3500
			})
		}
		if (error.status === 0 || error.status === undefined || error.status === null) {
			toaster.error("No internet connection detected. Please check your network settings and try again.", 'Error',{
				timeOut: 3500
			})
		}
		if (error.status === 401 ) {
			if(error.error.errorCode == 'INVALID_AY') {
				// Reloading here creates an infinite loop when the request is made
				// before the assessment-year header has been initialized. The
				// interceptor now supplies a local-storage fallback; if the server
				// still rejects the year, start a clean sign-in flow instead.
				this.router = AppInjector.get(Router);
				localStorage.clear();
				this.router.navigate(['/auth/sign-in']);
				toaster.error(error.error.errorMessage, 'Error', {timeOut: 2000});
				return throwError(() => error);
			} else {
				this.router = AppInjector.get(Router);
				localStorage.clear();
				this.router.navigate(['/auth/sign-in'])
				toaster.error(error.error.errorMessage,'Error', {timeOut: 2000});
			}
		}
		else if (error.status === 400 ) {
			this.router = AppInjector.get(Router);
			if (error.error.errorCode == "ERR60108" || error.error.errorCode == "ERR60107" || error.error.errorCode == "ERR60130" || error.error.errorCode == "ERR60131") {
				return throwError(error);
			}
			if (error.error.errors) {
				Object.keys(error.error.errors).forEach((key: string) => {
					toaster.error(error.error.errors[key],'Error', {timeOut: 2000});
				});
			} else {
				toaster.error(error.error.errorMessage,'Error', {timeOut: 2000});
			}

			const errorMessage = String(error?.error?.errorMessage ?? '');

			if (errorMessage.toLowerCase().includes('please save your assets')) {
				void this.router.navigate(['/user-panel/assets-and-liabilities']);
				return EMPTY;
			} else if (errorMessage.toLowerCase().includes('please save your expenditure')) {
				void this.router.navigate(['/user-panel/expenditure']);
				return EMPTY;
			}
			
      		return throwError( error );
		}
		if (error.status === 403 || error.status === 500 ) {
			toaster.error(error.error.errorMessage,'Error');
			return throwError( error );
		}
		else
		{
			return throwError( error );
		}
	  }


	public post(url: string, data: any, httpHeaders?: HttpHeaders): Observable<any> {
		// if(url substring upto /.equals(env.taxpayer_base_url))
		// 	url.replace(env.taxpayer_base_url, this.getContextBaseURL())
		let headers: HttpHeaders = httpHeaders != null ? httpHeaders : this.httpHeaders;
		return this.httpClient.post<any>(url, JSON.stringify(data), { headers: headers })
		.pipe(catchError(error => this.handleError(error)));
	}
	public put(url: string, data: any, httpHeaders?: HttpHeaders): Observable<any> {
		let headers = httpHeaders != null ? httpHeaders : this.httpHeaders;
		return this.httpClient.put<any>(url, JSON.stringify(data), { headers: headers })
		.pipe(catchError(error => this.handleError(error)));
	}
	public delete(url: string, httpHeaders?: HttpHeaders, params?: HttpParams): Observable<any> {
		let headers = httpHeaders != null ? httpHeaders : this.httpHeaders;
		if (params != null) {
			return this.httpClient.delete<any>(url, { headers: headers, params: params });
		} else {
			return this.httpClient.delete<any>(url, { headers: headers })
			.pipe(catchError(error => this.handleError(error)));
		}
		// return this.httpClient.delete<any>(url, { headers: headers });
	}
	public patch(url: string, data: any, httpHeaders?: HttpHeaders): Observable<any> {
		let headers = httpHeaders != null ? httpHeaders : this.httpHeaders;
		return this.httpClient.patch<any>(url, JSON.stringify(data), { headers: headers });
	}



}




